import { Injectable } from "@angular/core";
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SupplierRating, RatePurpose } from '../models/supplier-rating.model';
import { AppSettings } from "../../app.settings";

@Injectable()
export class SupplierRatingService extends BaseService {
    constructor(private http: HttpClient, private config: AppSettings) {
        super();
    }

    get(supplierCode: string): Observable<SupplierRating[]> {
        const url = `${this.config.BaseUrl}Profile/Rating/SupplierCode/${supplierCode}`;
        return this.http.get<SupplierRating[]>(url, { headers: this.setHeaders() });
    }

    getById(id: number): Observable<SupplierRating> {
        const url = `${this.config.BaseUrl}Profile/Rating/${id}`;
        return this.http.get<SupplierRating>(url, { headers: this.setHeaders() });
    }

    create(model: SupplierRating): Observable<SupplierRating> {
        const url = `${this.config.BaseUrl}Profile/Rating`;
        return this.http.post<SupplierRating>(url, model, { headers: this.setHeaders() });
    }

    update(id: number, model: SupplierRating): Observable<SupplierRating> {
        const url = `${this.config.BaseUrl}Profile/Rating/${id}`;
        return this.http.put<SupplierRating>(url, model, { headers: this.setHeaders() });
    }

    getPurpose(): Observable<RatePurpose[]> {
        const url = `${this.config.BaseUrl}Profile/Rating/Purpose`;
        return this.http.get<RatePurpose[]>(url, { headers: this.setHeaders() });
    }
}